<template>
    <DeleteElementForm :element="elementForDelete" @close="showDeletePopup = false" @acceptDeleteElement="deleteElement(elementForDelete)" v-if="showDeletePopup" />
    <ElementFilter v-if="filterFlag" :filter="filters" @dropFilters="dropFilters" @setFilters="e => setFilters(e)" @close="filterFlag = false" />
    <div class="overflow-y-auto">

        <!-- <div class="flex justify-between px-[84px]"> -->
            <!-- <div class="search-bar flex items-center border-[#FFF] border-[1px] bg-[#FFF] bg-opacity-30 px-[10px] rounded-[6px]">
                <img src="@/assets/icons/magnify_icon.svg" class="w-3 h-3">
                <input v-model="searchQuery" class="text-[#FFF] text-[14px] bg-transparent rounded-md px-2 py-[3.5px] placeholder:text-[#FFF] outline-none w-[250px] " placeholder="Пошук..." type="text">
            </div> -->

            <!-- <InputComponent :value="searchQuery" @update:modelValue="e => searchQuery = e" placeholder="Пошук..." class="w-[250px]"/>

            <div class="w-full ml-[30px] flex items-center ">
                <div class="text-[#8C8C8C] w-[250px] text-start font-medium relative text-[14px]">
                    Відображення елементів
                    <span v-if="elementsViewTable" class="text-[#8FC408]">таблиця</span>
                    <span v-else class="text-[#FA1367]">групи</span>
                </div>
                <div class="ml-[20px] relative bottom-[4px]">
                    <IphoneSwitch :isOnValue="elementsViewTable" @change="elementsViewTable = !elementsViewTable"/>
                </div>
            </div>
            <div class="w-max flex justify-end">
                <div @click="filterFlag = true" class="flex items-center cursor-pointer">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M8.85746 12.5061C6.36901 10.6456 4.59564 8.59915 3.62734 7.44867C3.3276 7.09253 3.22938 6.8319 3.17033 6.3728C2.96811 4.8008 2.86701 4.0148 3.32795 3.5074C3.7889 3 4.60404 3 6.23433 3H17.7657C19.396 3 20.2111 3 20.672 3.5074C21.133 4.0148 21.0319 4.8008 20.8297 6.37281C20.7706 6.83191 20.6724 7.09254 20.3726 7.44867C19.403 8.60062 17.6261 10.6507 15.1326 12.5135C14.907 12.6821 14.7583 12.9567 14.7307 13.2614C14.4837 15.992 14.2559 17.4876 14.1141 18.2442C13.8853 19.4657 12.1532 20.2006 11.226 20.8563C10.6741 21.2466 10.0043 20.782 9.93278 20.1778C9.79643 19.0261 9.53961 16.6864 9.25927 13.2614C9.23409 12.9539 9.08486 12.6761 8.85746 12.5061Z" stroke="#FFF" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                </div>
                <div class="ml-[20px] flex items-center w-[110px] justify-between mr-[140px] text-[#FFF]">
                    <img @click="prevPage" src="@/assets/icons/left_arrow.svg" class="cursor-pointer">
                    <div class="flex mx-[20px]">Сторінка: <input v-model="page" type="number" class="bg-transparent mx-2 w-[5ch] outline-none px-1"> / <span class="ml-[10px]">{{ maxPage }}</span></div>
                    <img @click="nextPage" src="@/assets/icons/right_arrow.svg" class="cursor-pointer">
                </div> -->
                <!-- <div @click="$router.push('/new-training-element')" class="bg-[#BD9135] flex justify-center items-center w-[228px] h-[38px] cursor-pointer text-white font-semibold py-[5px] rounded-lg">
                    <span>Додати елемент</span>
                </div> -->
                <!-- <div v-if="currentAdminRole != 'supervisor'" class="w-[228px]">
                    <ButtonComponent @click="() => $router.push('/new-training-element')">Додати</ButtonComponent>
                </div>
            </div>
        </div> -->

        <!-- <div class="border-b-[1px] border-white w-[90%] mx-auto flex justify-end mt-[16px] mb-[16px]">
            <div class="text-white ml-[20px]">
                <span class="text-[28px] font-semibold">{{ statistics.task }}</span> завдань
            </div>
            <div class="text-white ml-[20px]">
                <span class="text-[28px] font-semibold">{{ statistics.standard }}</span> тестування
            </div>
            <div class="text-white ml-[20px]">
                <span class="text-[28px] font-semibold">{{ statistics.exercise }}</span> вправи
            </div>
        </div> -->

        <main class="main__wrapper">
            <div class="main__section">
                <div class="search-header">
                    <div class="search-header__row">
                        <div class="search-header__sub-row">
                            <div class="search-bar">
                                <SearchInput :modelValue="searchQuery" @update:modelValue="e => searchQuery = e" />
                                <div 
                                    class="ml-[60px] flex items-center justify-between mr-[60px] text-[#FFF]">
                                    <!-- <img @click="prevPage" src="@/assets/icons/left_arrow.svg" class="cursor-pointer"> -->
                                    <div class="w-[36px] h-[36px] flex justify-center items-center cursor-pointer" @click="prevPage" >
                                        <svg width="35" height="34" viewBox="0 0 35 34" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <rect x="1.28613" y="0.5" width="33" height="33" rx="5.5" stroke="#474849"/>
                                            <path d="M11.7139 17L20.821 9.63878L20.821 24.3612L11.7139 17Z" fill="#474849"/>
                                        </svg>

                                    </div>
                                    <div class="flex mx-[10px]"><input v-model="page" type="number" class="bg-transparent border-[#474849] border-[1px] text-[12px] w-[34px] h-[34px] outline-none px-1 text-center rounded-[6px] mr-[10px]"> <span class="text-[10px] flex justify-center items-center">/</span> <span class="ml-[10px] border-[#474849] flex justify-center items-center bg-transparent border-[1px] w-[34px] h-[34px] text-[12px] outline-none px-1 text-center rounded-[6px] ">{{ maxPage }}</span></div>
                                    <!-- <img @click="nextPage" src="@/assets/icons/right_arrow.svg" class="cursor-pointer"> -->
                                    <div class="w-[36px] h-[36px] flex justify-center items-center cursor-pointer" @click="nextPage">
                                        <svg width="35" height="34" viewBox="0 0 35 34" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <rect x="0.857422" y="0.5" width="33" height="33" rx="5.5" stroke="#474849"/>
                                            <path d="M23.4287 17L14.3216 9.63878L14.3216 24.3612L23.4287 17Z" fill="#474849"/>
                                        </svg>

                                    </div>
                                </div>
                            </div>
                            <div class="w-full flex items-center ">
                                <!-- <div class="flex items-center cursor-pointer w-[24px] h-[24px] mr-[10px]" @click="filterFlag = true">
                                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M8.85746 12.5061C6.36901 10.6456 4.59564 8.59915 3.62734 7.44867C3.3276 7.09253 3.22938 6.8319 3.17033 6.3728C2.96811 4.8008 2.86701 4.0148 3.32795 3.5074C3.7889 3 4.60404 3 6.23433 3H17.7657C19.396 3 20.2111 3 20.672 3.5074C21.133 4.0148 21.0319 4.8008 20.8297 6.37281C20.7706 6.83191 20.6724 7.09254 20.3726 7.44867C19.403 8.60062 17.6261 10.6507 15.1326 12.5135C14.907 12.6821 14.7583 12.9567 14.7307 13.2614C14.4837 15.992 14.2559 17.4876 14.1141 18.2442C13.8853 19.4657 12.1532 20.2006 11.226 20.8563C10.6741 21.2466 10.0043 20.782 9.93278 20.1778C9.79643 19.0261 9.53961 16.6864 9.25927 13.2614C9.23409 12.9539 9.08486 12.6761 8.85746 12.5061Z" stroke="#FFF" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                    </svg>
                                </div> -->

                                <div class="flex items-center gap-[20px] cursor-pointer">
                                    <svg @click="filterFlag = true" width="35" height="34" viewBox="0 0 35 34" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <rect x="0.713867" y="0.5" width="33" height="33" rx="5.5" stroke="#474849"/>
                                        <path d="M11.7506 15.0363V9.48662C11.7506 9.30547 11.6787 9.13174 11.5506 9.00365C11.4225 8.87555 11.2487 8.80359 11.0676 8.80359C10.8864 8.80359 10.7127 8.87555 10.5846 9.00365C10.4565 9.13174 10.3845 9.30547 10.3845 9.48662V15.0363C9.79685 15.1868 9.27595 15.5286 8.90397 16.0078C8.53198 16.487 8.33008 17.0764 8.33008 17.6831C8.33008 18.2897 8.53198 18.8791 8.90397 19.3583C9.27595 19.8376 9.79685 20.1793 10.3845 20.3298V24.5134C10.3845 24.6946 10.4565 24.8683 10.5846 24.9964C10.7127 25.1245 10.8864 25.1964 11.0676 25.1964C11.2487 25.1964 11.4225 25.1245 11.5506 24.9964C11.6787 24.8683 11.7506 24.6946 11.7506 24.5134V20.3298C12.3383 20.1793 12.8592 19.8376 13.2312 19.3583C13.6032 18.8791 13.8051 18.2897 13.8051 17.6831C13.8051 17.0764 13.6032 16.487 13.2312 16.0078C12.8592 15.5286 12.3383 15.1868 11.7506 15.0363ZM11.0676 19.0491C10.7974 19.0491 10.5333 18.969 10.3086 18.8189C10.084 18.6688 9.90889 18.4554 9.80549 18.2058C9.7021 17.9562 9.67505 17.6815 9.72776 17.4165C9.78047 17.1516 9.91057 16.9081 10.1016 16.7171C10.2927 16.526 10.5361 16.3959 10.8011 16.3432C11.0661 16.2905 11.3407 16.3176 11.5904 16.421C11.84 16.5244 12.0533 16.6995 12.2034 16.9241C12.3535 17.1488 12.4336 17.4129 12.4336 17.6831C12.4336 18.0454 12.2897 18.3928 12.0335 18.649C11.7773 18.9052 11.4299 19.0491 11.0676 19.0491ZM17.8979 10.9381V9.48662C17.8979 9.30547 17.826 9.13174 17.6979 9.00365C17.5698 8.87555 17.3961 8.80359 17.2149 8.80359C17.0337 8.80359 16.86 8.87555 16.7319 9.00365C16.6038 9.13174 16.5319 9.30547 16.5319 9.48662V10.9381C15.9442 11.0885 15.4233 11.4303 15.0513 11.9096C14.6793 12.3888 14.4774 12.9782 14.4774 13.5848C14.4774 14.1915 14.6793 14.7809 15.0513 15.2601C15.4233 15.7393 15.9442 16.0811 16.5319 16.2316V24.5134C16.5319 24.6946 16.6038 24.8683 16.7319 24.9964C16.86 25.1245 17.0337 25.1964 17.2149 25.1964C17.3961 25.1964 17.5698 25.1245 17.6979 24.9964C17.826 24.8683 17.8979 24.6946 17.8979 24.5134V16.2316C18.4856 16.0811 19.0065 15.7393 19.3785 15.2601C19.7505 14.7809 19.9524 14.1915 19.9524 13.5848C19.9524 12.9782 19.7505 12.3888 19.3785 11.9096C19.0065 11.4303 18.4856 11.0885 17.8979 10.9381ZM17.2149 14.9509C16.9447 14.9509 16.6806 14.8708 16.456 14.7207C16.2313 14.5706 16.0562 14.3572 15.9528 14.1076C15.8494 13.858 15.8224 13.5833 15.8751 13.3183C15.9278 13.0533 16.0579 12.8099 16.2489 12.6189C16.44 12.4278 16.6834 12.2977 16.9484 12.245C17.2134 12.1923 17.4881 12.2194 17.7377 12.3228C17.9873 12.4261 18.2006 12.6012 18.3507 12.8259C18.5009 13.0505 18.581 13.3147 18.581 13.5848C18.581 13.9471 18.437 14.2946 18.1809 14.5508C17.9247 14.807 17.5772 14.9509 17.2149 14.9509ZM26.0944 20.4152C26.0938 19.8095 25.8923 19.2211 25.5215 18.7421C25.1507 18.2631 24.6315 17.9207 24.0453 17.7684V9.48662C24.0453 9.30547 23.9733 9.13174 23.8452 9.00365C23.7171 8.87555 23.5434 8.80359 23.3622 8.80359C23.1811 8.80359 23.0073 8.87555 22.8792 9.00365C22.7511 9.13174 22.6792 9.30547 22.6792 9.48662V17.7684C22.0915 17.9189 21.5706 18.2607 21.1986 18.7399C20.8266 19.2191 20.6247 19.8085 20.6247 20.4152C20.6247 21.0218 20.8266 21.6112 21.1986 22.0905C21.5706 22.5697 22.0915 22.9115 22.6792 23.062V24.5134C22.6792 24.6946 22.7511 24.8683 22.8792 24.9964C23.0073 25.1245 23.1811 25.1964 23.3622 25.1964C23.5434 25.1964 23.7171 25.1245 23.8452 24.9964C23.9733 24.8683 24.0453 24.6946 24.0453 24.5134V23.062C24.6315 22.9097 25.1507 22.5672 25.5215 22.0883C25.8923 21.6093 26.0938 21.0209 26.0944 20.4152ZM23.3622 21.7813C23.092 21.7813 22.8279 21.7011 22.6033 21.551C22.3786 21.4009 22.2035 21.1876 22.1001 20.938C21.9967 20.6884 21.9697 20.4137 22.0224 20.1487C22.0751 19.8837 22.2052 19.6403 22.3963 19.4492C22.5873 19.2582 22.8307 19.1281 23.0957 19.0754C23.3607 19.0227 23.6354 19.0497 23.885 19.1531C24.1346 19.2565 24.348 19.4316 24.4981 19.6562C24.6482 19.8809 24.7283 20.145 24.7283 20.4152C24.7283 20.7775 24.5844 21.125 24.3282 21.3812C24.072 21.6373 23.7245 21.7813 23.3622 21.7813Z" fill="#474849"/>
                                    </svg>

                                    <svg @click="elementsViewTable = true" width="35" height="34" viewBox="0 0 35 34" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <rect x="1.42871" y="0.5" width="33" height="33" rx="5.5" stroke="#474849"/>
                                        <path d="M27.946 7.89294H7.9103C7.42722 7.89294 6.96394 8.08484 6.62235 8.42643C6.28077 8.76801 6.08887 9.2313 6.08887 9.71437V24.2858C6.08887 24.7689 6.28077 25.2322 6.62235 25.5737C6.96394 25.9153 7.42722 26.1072 7.9103 26.1072H27.946C28.4291 26.1072 28.8924 25.9153 29.234 25.5737C29.5755 25.2322 29.7674 24.7689 29.7674 24.2858V9.71437C29.7674 9.2313 29.5755 8.76801 29.234 8.42643C28.8924 8.08484 28.4291 7.89294 27.946 7.89294ZM15.196 18.8215V15.1787H20.6603V18.8215H15.196ZM20.6603 20.6429V24.2858H15.196V20.6429H20.6603ZM7.9103 15.1787H13.3746V18.8215H7.9103V15.1787ZM15.196 13.3572V9.71437H20.6603V13.3572H15.196ZM22.4817 15.1787H27.946V18.8215H22.4817V15.1787ZM27.946 13.3572H22.4817V9.71437H27.946V13.3572ZM13.3746 9.71437V13.3572H7.9103V9.71437H13.3746ZM7.9103 20.6429H13.3746V24.2858H7.9103V20.6429ZM27.946 24.2858H22.4817V20.6429H27.946V24.2858Z" :fill="elementsViewTable ? '#C59014' : '#474849'"/>
                                    </svg>

                                    <svg @click="elementsViewTable = false" width="35" height="34" viewBox="0 0 35 34" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <rect x="1.14258" y="0.5" width="33" height="33" rx="5.5" stroke="#474849"/>
                                        <path d="M26.7506 17.9108H8.53627C8.0532 17.9108 7.58991 18.1027 7.24833 18.4443C6.90674 18.7859 6.71484 19.2492 6.71484 19.7322V24.2858C6.71484 24.7689 6.90674 25.2322 7.24833 25.5737C7.58991 25.9153 8.0532 26.1072 8.53627 26.1072H26.7506C27.2336 26.1072 27.6969 25.9153 28.0385 25.5737C28.3801 25.2322 28.572 24.7689 28.572 24.2858V19.7322C28.572 19.2492 28.3801 18.7859 28.0385 18.4443C27.6969 18.1027 27.2336 17.9108 26.7506 17.9108ZM26.7506 24.2858H8.53627V19.7322H26.7506V24.2858ZM26.7506 7.89294H8.53627C8.0532 7.89294 7.58991 8.08484 7.24833 8.42643C6.90674 8.76801 6.71484 9.2313 6.71484 9.71437V14.2679C6.71484 14.751 6.90674 15.2143 7.24833 15.5559C7.58991 15.8975 8.0532 16.0894 8.53627 16.0894H26.7506C27.2336 16.0894 27.6969 15.8975 28.0385 15.5559C28.3801 15.2143 28.572 14.751 28.572 14.2679V9.71437C28.572 9.2313 28.3801 8.76801 28.0385 8.42643C27.6969 8.08484 27.2336 7.89294 26.7506 7.89294ZM26.7506 14.2679H8.53627V9.71437H26.7506V14.2679Z" :fill="!elementsViewTable ? '#C59014' : '#474849'"/>
                                    </svg>
                                </div>

                                <!-- <div class="text-[#8C8C8C] w-[250px] text-start font-medium relative text-[14px]">
                                    Відображення елементів
                                    <span v-if="elementsViewTable" class="text-[#8FC408]">таблиця</span>
                                    <span v-else class="text-[#FA1367]">групи</span>

                                    
                                </div>
                                <div class="ml-[20px] relative">
                                    <IphoneSwitch :isOnValue="elementsViewTable" @change="elementsViewTable = !elementsViewTable"/>
                                </div> -->
                            </div>
                        </div>
                        <ButtonComponent @click="() => $router.push('/new-training-element')" v-if="currentAdminRole != 'supervisor'">Додати</ButtonComponent>
                    </div>
                </div>
                <div class="border-b-[1px] border-[#8f8f8f] w-[100%] pb-[12px] mx-auto flex justify-end mt-[16px] mb-[16px]">
                    <div class="text-[#8f8f8f] ml-[20px]">
                        <span class="text-[28px] font-semibold">{{ statistics.task }}</span> завдань
                    </div>
                    <div class="text-[#8f8f8f] ml-[20px]">
                        <span class="text-[28px] font-semibold">{{ statistics.standard }}</span> тестування
                    </div>
                    <div class="text-[#8f8f8f] ml-[20px]">
                        <span class="text-[28px] font-semibold">{{ statistics.exercise }}</span> вправи
                    </div>
                </div>
                <div class="player-groups">
                    <TableWrapper v-if="elementsViewTable">
                        <TableComponent :fullWidth="true">
                            <TableHeader>
                                <TableHeaderRow>
                                    <TableHeaderCell
                                        value=""
                                        :width="50"
                                        :textStart="true"
                                    />
                                    <TableHeaderCell
                                        value="Назва елементу"
                                        :width="100"
                                        :textStart="true"
                                    />
                                    <TableHeaderCell
                                        value="Елемент"
                                        :width="200"
                                        :textStart="true"
                                    />
                                    <TableHeaderCell value="Блок/Вікова категорія" :width="100" />
                                    <TableHeaderCell value="Тривалість" :width="100" />
                                    <TableHeaderCell value="Направленість" :width="100" />
                                    <TableHeaderCell value="" :width="100" />
                                </TableHeaderRow>
                            </TableHeader>
                            <TableBody>
                                <TableRow v-for="element in trainingElements" v-if="trainingElements.length">
                                    <TableCell :asChild="true">
                                        <div class="rounded-full border-[1px] bg-[#BD9135] border-white w-[50px] h-[50px] flex justify-center items-center text-center align-middle">
                                            <span class="text-[21px]">{{ element.name ? element.name[0].toUpperCase() : 'N' }}</span>
                                        </div>
                                    </TableCell>
                                    <TableCell :asChild="true">
                                        <div class="text-start pl-[20px]">
                                            {{ element.name ? element.name : 'Немає назви' }}
                                        </div>
                                    </TableCell>
                                    <TableCell :asChild="true">
                                        <div class="w-full h-full flex justify-center">
                                            {{ parseElementType(element.type) }}
                                        </div>
                                    </TableCell>
                                    <TableCell :asChild="true">
                                        <div :style="[`${!element.training_program_years && element.type != 'standard' ? 'opacity: 0.4' : ''}`]">
                                            {{ element.type == 'standard' ? element.training_program_years.split('_')[0] + ' років' : parseAgeGroup(element.training_program_years) }}
                                        </div>
                                    </TableCell>
                                    <TableCell :asChild="true">
                                        <div>
                                            {{ element.time ?? 'Налаштовувана' }}
                                        </div>
                                    </TableCell>
                                    <TableCell :asChild="true" :text-end="true">
                                        <div class="flex justify-start gap-[5px] w-[600px] overflow-auto">
                                            <!-- {{ element.element_direction ? parseElementDirection(element.element_direction) : '-' }} -->
                                            <div v-for="direction in element.detailDirection" :style="[`background-color: ${direction.color}; width: max-content;`]" class="rounded-[6px] text-white text-[12px] px-[10px] py-[3px]">
                                                {{ direction.name }} ({{ (+direction?.percent).toFixed(2) }})
                                            </div>
                                        </div>
                                    </TableCell>
                                    <TableCell :asChild="true" :text-end="true">
                                        <div class="flex justify-end">
                                            <button 
                                                class="py-1 rounded-[10px] text-sm font-medium mr-[20px]"
                                                @click="$router.push(`/training-element/${element.element_id}`)"
                                            >
                                                <img 
                                                    src="@/assets/icons/pen_icon.svg" 
                                                    class="w-6 h-6"
                                                >
                                            </button>
                                            <button 
                                                v-if="currentAdminRole != 'supervisor'"
                                                class="py-1 rounded-[10px] text-sm font-medium text-red-600"
                                                @click="elementForDelete = element; showDeletePopup = true"
                                            >
                                                <img 
                                                    src="@/assets/icons/trash_icon.svg" 
                                                    class="w-6 h-6"   
                                                >
                                            </button>
                                        </div>
                                    </TableCell>
                                </TableRow>
                            </TableBody>
                        </TableComponent>
                    </TableWrapper>
                </div>
            </div>
        </main>



        <div v-if="elementsViewTable" class=" w-[90%] mx-auto mt-3 mb-5 rounded-[10px] overflow-y-auto">
            <!-- <table class="w-full">
                <thead class="text-white select-none">
                    <tr class="border-b-[1px] border-[#FFF] border-opacity-10 text-white">
                        <th class="px-3 py-2 w-[5%] text-center font-bold text-sm"></th>
                        <th class="px-3 py-2 w-[20%] text-start font-bold text-sm">Назва елементу</th>
                        <th class="px-3 py-2 w-[10%] text-center font-bold text-sm">Елемент</th>
                        <th class="px-3 py-2 w-[10%] text-end font-bold text-sm">Вік. кат.</th>
                        <th class="w-[15%] py-2 cursor-pointer select-none text-end font-bold text-sm">
                            Тривалість
                        </th>
                        <th class="w-[5%]" ></th>
                        <th class="px-3 py-2 text-end w-[204px] relative font-bold text-sm">
                            Направленість
                        </th>
                        <th class="px-3 w-[25%] py-2 text-end font-bold text-sm"></th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="element in trainingElements" v-if="trainingElements.length" class="border-b-[1px] border-[#FFF] border-opacity-10 text-white">
                        <td class="px-3 py-2 w-[5%] text-center font-medium text-sm">
                            <div class="rounded-full border-[1px] bg-[#BD9135] border-white w-[50px] h-[50px] flex justify-center items-center text-center align-middle">
                                <span class="text-[21px]">{{ element.name ? element.name[0].toUpperCase() : 'N' }}</span>
                            </div>
                        </td>
                        <td class="px-3 py-2 w-[20%] text-start font-medium text-sm">{{ element.name ? element.name : 'Немає назви' }}</td>
                        <td class="px-3 py-2 w-[10%] text-center font-medium text-sm text-[#BD9135]">{{ parseElementType(element.type) }}</td>
                        <td class="px-3 py-2 w-[10%] text-end font-medium text-sm">{{ parseAgeGroup(element.training_program_years) }}</td>
                        <td class="w-[15%] py-2 select-none text-end font-medium text-sm">
                            {{ element.time ?? 'Налаштовувана' }}
                        </td>
                        <td class="w-[5%]" ></td>
                        <td class="px-3 py-2 text-end w-[204px] relative font-medium text-sm">
                            {{ element.element_direction ? parseElementDirection(element.element_direction) : '-' }}
                        </td>
                        <td class="px-3 w-[25%] py-2 text-end font-medium text-sm">
                            <button 
                                class="py-1 rounded-[10px] text-sm font-medium mr-[20px]"
                                @click="$router.push(`/training-element/${element.element_id}`)"
                            >
                                <img 
                                    src="@/assets/icons/pen_icon.svg" 
                                    class="w-6 h-6"
                                >
                            </button>
                            <button 
                                v-if="currentAdminRole != 'supervisor'"
                                class="py-1 rounded-[10px] text-sm font-medium text-red-600"
                                @click="elementForDelete = element; showDeletePopup = true"
                            >
                                <img 
                                    src="@/assets/icons/trash_icon.svg" 
                                    class="w-6 h-6"   
                                >
                            </button>
                        </td>
                    </tr>
                    <tr v-else>
                        <td class="px-3 py-2 w-[20%] text-center font-bold text-white" colspan="8">Немає елементів</td>
                    </tr>
                </tbody>
            </table> -->
        </div>
        <div v-else class="my-[0px]">
            <div v-if="!selectedGroupAgeGroup" class="main__wrapper">
                <div class="main__section">
                    <TrainingElementFoldersGrid
                        :editable="true"
                        :show-coach-tabs="true"
                        @select="onFolderSelect"
                    />
                </div>
            </div>
            <div v-else class="w-[90%] mx-auto mt-3 mb-5 rounded-[10px] overflow-y-auto">
                <div @click="goBackFromFolder" class="bg-[#BD9135] flex justify-center mb-[20px] items-center w-[228px] h-[38px] cursor-pointer text-white font-semibold py-[5px] rounded-lg">
                    <span>Назад</span>
                </div>
                <div class="text-white text-center font-semibold text-lg mb-[8px]">
                    {{ selectedGroupAgeGroup }}
                </div>
                <FolderSubfoldersPanel
                    v-if="selectedFolder"
                    :folder-id="selectedFolder.id"
                    :subfolders="selectedFolder.subfolders || []"
                    :editable="true"
                    @select="onSubfolderSelect"
                    @changed="refreshSelectedFolder"
                />
                <!-- <table class="w-full">
                    <thead class="text-white select-none">
                        <tr class="border-b-[1px] border-[#FFF] border-opacity-10 text-white">
                            <th class="px-3 py-2 w-[5%] text-center font-bold text-sm"></th>
                            <th class="px-3 py-2 w-[20%] text-start font-bold text-sm">Назва елементу</th>
                            <th class="px-3 py-2 w-[10%] text-center font-bold text-sm">Елемент</th>
                            <th class="px-3 py-2 w-[10%] text-end font-bold text-sm">Блок</th>
                            <th class="w-[15%] py-2 cursor-pointer select-none text-end font-bold text-sm">
                                Тривалість
                            </th>
                            <th class="w-[5%]" ></th>
                            <th class="px-3 py-2 text-end w-[204px] relative font-bold text-sm">
                                Направленість
                            </th>
                            <th class="px-3 w-[25%] py-2 text-end font-bold text-sm"></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="element in trainingElements" v-if="trainingElements.length" class="border-b-[1px] border-[#FFF] border-opacity-10 text-white">
                            <td class="px-3 py-2 w-[5%] text-center font-medium text-sm">
                                <div class="rounded-full border-[1px] bg-[#BD9135] border-white w-[50px] h-[50px] flex justify-center items-center text-center align-middle">
                                    <span class="text-[21px]">{{ element.name ? element.name[0].toUpperCase() : 'N' }}</span>
                                </div>
                            </td>
                            <td class="px-3 py-2 w-[20%] text-start font-medium text-sm">{{ element.name ? element.name : 'Немає назви' }}</td>
                            <td class="px-3 py-2 w-[10%] text-center font-medium text-sm text-[#BD9135]">{{ parseElementType(element.type) }}</td>
                            <td class="px-3 py-2 w-[10%] text-end font-medium text-sm">{{ parseAgeGroup(element.training_program_years) }}</td>
                            <td class="w-[15%] py-2 select-none text-end font-medium text-sm">
                                {{ element.time ?? 'Налаштовувана' }}
                            </td>
                            <td class="w-[5%]" ></td>
                            <td class="px-3 py-2 text-end w-full relative font-medium text-sm flex">
                                <div class="flex justify-start gap-[5px] w-[600px] overflow-auto">
                                    <div v-for="direction in element.detailDirection" :style="[`background-color: ${direction.color}; width: max-content;`]" class="rounded-[6px] text-white text-[12px] px-[10px] py-[3px]">
                                        {{ direction.name }} ({{ (+direction?.percent).toFixed(2) }})
                                    </div>
                                </div>
                            </td>
                            <td class="px-3 w-[25%] py-2 text-end font-medium text-sm">
                                <button 
                                    class="py-1 rounded-[10px] text-sm font-medium mr-[20px]"
                                    @click="$router.push(`/training-element/${element.element_id}`)"
                                >
                                    <img 
                                        src="@/assets/icons/pen_icon.svg" 
                                        class="w-6 h-6"
                                    >
                                </button>
                                <button 
                                    v-if="currentAdminRole != 'supervisor'"
                                    class="py-1 rounded-[10px] text-sm font-medium text-red-600"
                                    @click="elementForDelete = element; showDeletePopup = true"
                                >
                                    <img 
                                        src="@/assets/icons/trash_icon.svg" 
                                        class="w-6 h-6"   
                                    >
                                </button>
                            </td>
                        </tr>
                        <tr v-else>
                            <td class="px-3 py-2 w-[20%] text-center font-bold text-white" colspan="8">Немає елементів</td>
                        </tr>
                    </tbody>
                </table> -->

                <div class="elements-grid">
                    <div v-for="element in trainingElements" v-if="trainingElements.length" @click="$router.push(`/training-element/${element.element_id}`)" class="elements-card w-full cursor-pointer">
                        <div v-if="element.additional_videos[0]" class="w-full" @click.stop>
                            <TrainingElementVideoPlayer
                                :src="element.additional_videos[0]"
                                width="100%"
                                height="150px"
                                variant="card"
                            />
                        </div>
                        <h3 class="text-lg font-semibold">{{ element.name ? element.name : 'Немає назви' }}</h3>
                        <div class="direction-grid">
                            <div v-for="direction in element.detailDirection" :style="[`background-color: ${direction.color}; width: max-content;`]" class="rounded-[6px] text-white text-[10px] px-[10px] py-[1.5px]">
                                {{ direction.name }} ({{ (+direction?.percent).toFixed(2) }})
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { ref, onMounted, watch } from 'vue'
    import { getAllTrainingElementsRequest, deleteElementByIdRequest, getStatisticsByElements, getAllTrainingElementFoldersWithSubfolders } from '@/services/apiRequests.js'
    import DeleteElementForm from './components/DeleteElementForm.vue'
    import ElementFilter from './components/ElementFilter.vue'
    import IphoneSwitch from './components/IphoneSwitch.vue'
    import ButtonComponent from '@/components/uikit/Button/ButtonComponent.vue'
    import InputComponent from '@/components/uikit/Input/InputComponent.vue'
    import TrainingElementVideoPlayer from '@/components/TrainingElementVideoPlayer.vue'
    import TrainingElementFoldersGrid from '@/views/TrainingSummary/components/TrainingElementFoldersGrid.vue'
    import FolderSubfoldersPanel from '@/views/TrainingSummary/components/FolderSubfoldersPanel.vue'

    export default {
        name: 'TrainingElements',

        setup() {
            const trainingElements = ref([])
            const elementsCount = ref(20)
            const elementSkip = ref(0)
            const elementForDelete = ref(null)
            const showDeletePopup = ref(false)
            const statistics = ref({
                standard: 0,
                exercise: 0,
                task: 0
            })

            const searchQuery = ref('')

            const page = ref(1)
            const maxPage = ref(1)

            const elementsViewTable = ref(false)
            const selectedGroupAgeGroup = ref(null)
            const selectedFolder = ref(null)
            const selectedGroupElementType = ref(null)
            const selectedElementDirection = ref(null)

            const onFolderSelect = (folder) => {
                selectedFolder.value = folder
                selectedGroupAgeGroup.value = folder.name
                selectedGroupElementType.value = 'task'
                selectedElementDirection.value = 'all'
                page.value = 1
            }

            const onSubfolderSelect = (subfolderName) => {
                selectedGroupAgeGroup.value = subfolderName
                selectedFolder.value = null
                selectedGroupElementType.value = 'task'
                selectedElementDirection.value = 'all'
                page.value = 1
            }

            const goBackFromFolder = () => {
                selectedGroupAgeGroup.value = null
                selectedFolder.value = null
                selectedGroupElementType.value = null
                selectedElementDirection.value = null
            }

            const refreshSelectedFolder = async () => {
                if (!selectedFolder.value?.id) return
                const response = await getAllTrainingElementFoldersWithSubfolders()
                const folders = Array.isArray(response) ? response : []
                const entry = folders.find((e) => e.folder?.id === selectedFolder.value.id)
                if (entry) {
                    selectedFolder.value = {
                        id: entry.folder.id,
                        name: entry.folder.name,
                        coach_type: entry.folder.coach_type,
                        subfolders: entry.subfolders || []
                    }
                    selectedGroupAgeGroup.value = entry.folder.name
                } else {
                    goBackFromFolder()
                }
            }

            watch(elementsViewTable, async (value) => {
                filters.value = {
                    elementType: 'all',
                    ageCategory: 'all',
                    assessmentType: 'all',
                    direction: 'all',
                    timeSort: 'none',
                }

                selectedGroupAgeGroup.value = null
                selectedFolder.value = null
                selectedGroupElementType.value = null
                selectedElementDirection.value = null

                await updateElements()
            })

            const parseElementDirection = (direction) => {
                switch (direction) {
                    case 'physical':
                        return 'Фізичне'
                    case 'tactical':
                        return 'Тактичне'
                    case 'technical':
                        return 'Технічне'
                    case 'tech_tactical':
                        return 'Техніко/тактичне'
                    default:
                        return 'Невідома направленість'
                }
            }

            watch(selectedGroupElementType, async (value) => {
                if (value) {
                    const response = await getAllTrainingElementsRequest(20 * page.value, 20 * (page.value - 1), {
                        elementType: selectedGroupElementType.value ?? 'all',
                        ageCategory: selectedGroupAgeGroup.value ?? 'all',
                        assessmentType: 'all',
                        direction: selectedElementDirection.value ?? 'all',
                        timeSort: 'none',
                    }, searchQuery.value)
                    filters.value = {
                        elementType: selectedGroupElementType.value ?? 'all',
                        ageCategory: selectedGroupAgeGroup.value ?? 'all',
                        assessmentType: 'all',
                        direction: selectedElementDirection.value ?? 'all',
                        timeSort: 'none',
                    }
                    console.log('filters.value ------- ', filters.value)
                    trainingElements.value = response
                }
            })
            watch(selectedElementDirection, async (value) => {
                if (value) {
                    const response = await getAllTrainingElementsRequest(20 * page.value, 20 * (page.value - 1), {
                        elementType: selectedGroupElementType.value ?? 'all',
                        ageCategory: selectedGroupAgeGroup.value ?? 'all',
                        assessmentType: 'all',
                        direction: selectedElementDirection.value ?? 'all',
                        timeSort: 'none',
                    }, searchQuery.value)
                    filters.value = {
                        elementType: selectedGroupElementType.value ?? 'all',
                        ageCategory: selectedGroupAgeGroup.value ?? 'all',
                        assessmentType: 'all',
                        direction: selectedElementDirection.value ?? 'all',
                        timeSort: 'none',
                    }
                    console.log('filters.value ------- ', filters.value)
                    trainingElements.value = response
                }
            })

            const filters = ref({
                elementType: 'all',
                ageCategory: 'all',
                assessmentType: 'all',
                direction: 'all',
                timeSort: 'none',
            })

            const filterFlag = ref(false)

            const prevPage = () => {
                page.value > 1 ? page.value-- : page.value = 1
            }

            const nextPage = () => {
                maxPage.value >= page.value + 1 ? page.value++ : page.value = maxPage.value
            }

            watch(page, async (value) => {
                await updateElements()
            })

            watch(searchQuery, async (value) => {
                await updateElements()
            })

            const setFilters = async (newFilters) => {
                console.log('newFilters --- ', newFilters)
                filters.value = newFilters
                filterFlag.value = false

                console.log(filters.value)

                await updateElements()
            }

            const dropFilters = async () => {
                filters.value = {
                    elementType: 'all',
                    ageCategory: 'all',
                    assessmentType: 'all',
                    direction: 'all',
                    timeSort: 'none',
                }
                filterFlag.value = false

                await updateElements()
            }

            const parseElementType = (type) => {
                switch (type) {
                    case 'standard':
                        return 'Норматив'
                    case 'exercise':
                        return 'Вправа'
                    case 'task':
                        return 'Завдання'
                    case 'warmup_ofp':
                        return 'Розминка (ОФП)'
                    case 'warmup_sfp':
                        return 'Розминка (СФП)'
                    case 'hitch_ofp':
                        return 'Заминка (ОФП)'
                    default:
                        return 'Невідомий тип елементу'
                }
            }

            const parseAgeGroup = (ageGroup) => {
                if (!ageGroup) return '—'
                if (typeof ageGroup === 'string' && ageGroup.endsWith('_years')) {
                    return ageGroup.split('_')[0] + ' років'
                }
                if (ageGroup === 'main_team') return 'Основна команда'
                return ageGroup
            }

            const parseScoring = (scoring) => {
                switch (scoring) {
                    case 'time':
                        return 'Час'
                    case 'point':
                        return 'Оцінка'
                    case 'length':
                        return 'Відстань'
                    case 'count':
                        return 'Кількість'
                    case 'coefficient':
                        return 'Коефіцієнт'
                    default:
                        return '-'
                }
            }

            const deleteElement = async (element) => {
                await deleteElementByIdRequest(element.element_id)
                await updateElements()
                showDeletePopup.value = false
            }

            const updateElements = async () => {
                const response = await getAllTrainingElementsRequest(20 * page.value, 20 * (page.value - 1), filters.value, searchQuery.value)
                console.log('response --- ', response)
                console.log('filters.value --- ', filters.value)
                trainingElements.value = response
            }

            const getStatistics = async () => {
                const response = await getStatisticsByElements()
                statistics.value = response
            }

            onMounted(async () => {
                await updateElements()
                await getStatistics()

                maxPage.value = Math.ceil((statistics.value.standard + statistics.value.exercise + statistics.value.task) / 20)
            })

            const currentAdminRole = ref(localStorage.getItem('userType'))

            return {
                trainingElements,
                parseElementType,
                parseAgeGroup,
                parseScoring,
                elementForDelete,
                showDeletePopup,
                deleteElement,
                statistics,
                page,
                prevPage,
                nextPage,
                maxPage,
                filterFlag,
                filters,
                setFilters,
                searchQuery,
                dropFilters,
                elementsViewTable,
                selectedGroupAgeGroup,
                selectedFolder,
                selectedGroupElementType,
                selectedElementDirection,
                onFolderSelect,
                onSubfolderSelect,
                goBackFromFolder,
                refreshSelectedFolder,
                parseElementDirection,
                currentAdminRole
            }
        },

        components: {
            DeleteElementForm,
            ElementFilter,
            IphoneSwitch,
            TrainingElementVideoPlayer,
            TrainingElementFoldersGrid,
            FolderSubfoldersPanel
        },
    }
</script>

<style lang="scss" scoped>
    .search-bar {
        display: flex;
        gap: 10px;
    }

    .search-header__sub-row {
        display: flex;
        align-items: center;
        gap: 10px;
    }

    .search-header__row {
        display: flex;
        justify-content: space-between;
        align-items: center;
        gap: 10px;
    }

    @media screen and (max-width: 1450px) {
        .search-bar {
            flex-direction: column;
            align-items: center;
        }
    }

    @media screen and (max-width: 1150px) {
        .search-bar {
            flex-direction: column;
            align-items: center;
        }

        .search-header__sub-row {
            flex-direction: column;
            align-items: center;
        }
    }

    @media screen and (max-width: 890px) {
        .search-header__row {
            flex-direction: column;
            align-items: center;
        }
    }

    input::-webkit-outer-spin-button,
    input::-webkit-inner-spin-button {
        /* display: none; <- Crashes Chrome on hover */
        -webkit-appearance: none;
        margin: 0; /* <-- Apparently some margin are still there even though it's hidden */
    }

    input[type=number] {
        -moz-appearance:textfield; /* Firefox */
    }

    .elements-grid {
        display: grid;
        grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
        gap: 20px;
        margin-top: 20px;
    }

    .direction-grid {
        display: grid;
        grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));
        gap: 10px;
        margin-top: 10px;
    }
</style>